import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import ModalDialog from "./ModalDialog";
import {
  closeModalDialog,
  changeModalDialogElementType,
} from "../../../../actions/layoutActions";
import useActiveEditing from "../../../hooks/useActiveEditing";

export function ModalDialogContainer({
  modalDialog,
  closeModalDialog,
  changeModalDialogElementType,
}) {
  const { onCloseModal } = modalDialog;

  // While any modal is open, all background auto-saves are deferred so that
  // PATCH responses don't trigger re-renders that would close date pickers or
  // reset form state inside the modal.
  useActiveEditing(!!modalDialog.isOpen);

  return (
    <ModalDialog
      {...modalDialog}
      onTabChange={changeModalDialogElementType}
      closeModalDialog={onCloseModal || closeModalDialog}
    />
  );
}

ModalDialogContainer.propTypes = {
  modalDialog: PropTypes.object.isRequired,
  closeModalDialog: PropTypes.func.isRequired,
  changeModalDialogElementType: PropTypes.func.isRequired,
};

const mapStateToProps = ({ layout }) => ({
  modalDialog: layout.modalDialog,
});

const mapDispatchToProps = {
  closeModalDialog,
  changeModalDialogElementType,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ModalDialogContainer);
